import { BackendWorkflow, Node, NoteNode } from 'modules/workflows/types';
import { WorkflowState } from '../ducks';
import { parseEdge } from './edgeUtils';
import { parseBackendNodes } from './nodeUtils';

export const hydrateNote = (note: NoteNode) => ({ ...note, isHidden: false });

/**
 * Parses nodes, edges and notes from the backend into a formula that can be
 * used to display the workflow in a preview.
 *
 * @param {BackendWFNode[]} param0.nodes The nodes from backend to parse
 * @param {BackendNoteNode[]} param0.notes The notes from backend to parse
 * @param {BackendEdge[]} param0.edges The edges from backend to parse
 * @param {WorkflowState} wfState The current state for the workflow
 */

export const parseForInsertPreview = (
  { nodes = [], notes = [], edges = [] }: Pick<BackendWorkflow, 'nodes' | 'notes' | 'edges'>,
  wfState: WorkflowState,
) => {
  const parsedNodes = parseBackendNodes({ nodes, notes, shouldValidate: false }, wfState).map(
    (x: Node) => {
      const node = { ...x, canDelete: false };
      return x.isNote ? hydrateNote(node) : node;
    },
  );

  return {
    parsedNodesForDisplay: parsedNodes || [],
    parsedEdgesForDisplay: edges?.map(parseEdge) || [],
  };
};
